"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const material_ui_confirm_1 = require("material-ui-confirm");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
function default_1({ isRegisterComplete, pendingRef, closeDialog, }) {
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const onCloseDialogClick = () => {
        if (isRegisterComplete) {
            closeDialog();
        }
        else if (!pendingRef.current) {
            confirm({
                description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t('이대로 나가면 정보가 등록되지 않아요.'), (0, jsx_runtime_1.jsx)("br", {}), t('나가시겠어요?')] })),
                confirmationText: t('나갈게요'),
            })
                .then(closeDialog)
                .catch(() => { });
        }
    };
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "surface-white", css: {
            flexShrink: 0,
            position: 'sticky',
            top: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '56px',
            zIndex: 1,
        } }, { children: [(0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ onClick: onCloseDialogClick, sx: { position: 'absolute', left: '12px' } }, { children: (0, jsx_runtime_1.jsx)(svgs_1.HeaderCloseSvg, {}) })), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2 gray-80" }, { children: t('사업자 정보') }))] })));
}
exports.default = default_1;
